<footer>   
    <div class="content">
        <div class="container">
            <div class="row">
                <div class="col-md-3 col-item">
                    <h3 class="title-h3">Menu</h3>
                    <ul class="menu-list">
                        <li>
                            <a routerLink="/quem-somos" title="Quem Somos">
                                Quem Somos
                            </a> 
                        </li>
                        <li>
                            <a routerLink="/cases" title="Cases">
                                Cases
                            </a> 
                        </li>
                        <li>
                            <a routerLink="/contato" title="Contato">
                                Contato
                            </a> 
                        </li>
                        <li>
                            <a routerLink="/meus-pedidos" title="Meus Pedidos">
                                Meus Pedidos
                            </a> 
                        </li>
                    </ul>
                </div>
                <div class="col-md-3 col-item col-contact">
                    <h3 class="title-h3">Horário de Atendimento</h3>
                    <modulo posicao="contato" template="horario"></modulo>
                    <h3 class="title-h3">Endereço</h3>
                    <modulo posicao="endereco" template="footer"></modulo> 
                    <h3 class="title-h3">Redes Sociais</h3>
                    <modulo posicao="rede-social" template="footer"></modulo> 
                </div>
                <div class="col-md-3 col-item">
                    <h3 class="title-h3">Contatos</h3>
                    <modulo posicao="contato" template="footer"></modulo>
                </div>
                <div class="col-md-3 col-item">
                    <h3 class="title-h3">Está com dúvidas?</h3>
                    <h4 class="title-h4">Entre em contato:</h4>
                    <div class="content-form">
                        <contact-form></contact-form>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <modulo class="logo-footer" posicao="logo" template="footer"></modulo>
                </div>
            </div>
        </div>  
    </div>    
    <div class="bottom">
        <div class="container">
            <div class="copyright">
                <p>
                    <span>Copyright © 2025</span>
                    <a href="https://digitalmovement.com.br/" target="_blank" title="Digital Movement - Soluções em Tecnologia">
                        <strong>Digital Movement</strong>
                        <img src="images/logos/logo-dm.svg" alt="Digital Movement - Especialista em Tecnologia" width="20px" height="20px" loading="lazy" />
                    </a>
                </p>
            </div> 
        </div>  
    </div>    
</footer>        